import axios from 'axios'

/**
 * The TanStack Query `retry` predicate (SC-1). A retry inside the same rate-limit window cannot
 * succeed -- it just burns another permit and delays the error the user needs to see -- so a 429 is
 * never retried. Everything else keeps the single retry.
 *
 * Lives in its own module (not inline in AppProviders) so it can be unit-tested without loading
 * AppProviders' module-level maplibre/pmtiles side effects, which do not initialise under jsdom.
 */
export function retryUnlessThrottled(failureCount: number, error: unknown): boolean {
  if (axios.isAxiosError(error) && error.response?.status === 429) return false
  return failureCount < 1
}
